import { useContext } from 'react'

import Section from '../../../components/section'
import { useAuthentication } from '../../../providers/auth-provider'
import PeopleContext from '../context'

import AccountsContent from './accounts'
import AddressContent from './address'
import AppsContent, { AppsInvitePwResetButton } from './apps'
import ManageContent from './manage'
import PreferencesContent from './preferences'

const DetailsTab = () => {
  const initialProps = { isEditing: false, setIsEditing: () => {} }

  const { hasInternalUserAccess, ownUser } = useAuthentication()
  const { user } = useContext(PeopleContext)

  return (
    <>
      <Section component={<PreferencesContent {...initialProps} />} showEdit={hasInternalUserAccess} title="Preferences" />
      <Section component={<AccountsContent {...initialProps} />} showEdit={hasInternalUserAccess} title="Accounts" />
      <Section component={<AppsContent />} title="Apps" showEdit={false} actionButton={<AppsInvitePwResetButton />} />
      <Section component={<AddressContent {...initialProps} />} showEdit={hasInternalUserAccess} title="Address" />
      {((ownUser && ownUser.id === user?.id) || hasInternalUserAccess) && <Section component={<ManageContent />} title="Manage" showEdit={false} />}
    </>
  )
}

export default DetailsTab
